export const LP_SETTLEMENT_BLOTTER_PREFIX = 'lp-settlement';

export const LP_SETTLEMENT_BLOTTER_PORTAL_ID = 'LpSettlementBlotterPortal';
